import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class MixedCheckeredShirt extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.MixedCheckeredShirt.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.MixedCheckeredShirt.itemName}
                />
                <InfoItem
                    price={AW21.tops.MixedCheckeredShirt.itemPrice}
                    fabric={AW21.tops.MixedCheckeredShirt.itemFabric}
                />
                <SizeChart src={AW21.tops.MixedCheckeredShirt.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.MixedCheckeredShirt.picture01}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.MixedCheckeredShirt.picture02}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.MixedCheckeredShirt.picture03}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.MixedCheckeredShirt.picture04}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>


                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.MixedCheckeredShirt.shopifyDivId}
                    mainId={AW21.tops.MixedCheckeredShirt.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default MixedCheckeredShirt;
